import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Introducing from "./components/Introducing";
import Features from "./components/Features";
import Performance from "./components/Performance";
import HowItWorks from "./components/HowItWorks";
import NextMoves from "./components/NextMoves";
import Footer from "./components/Footer";
import GetStartedPage from "./components/GetStartedPage";

function Landing() {
  return (
    <div className="page-bg min-h-screen relative overflow-x-hidden">
      <div className="bg-fx" aria-hidden="true" />
      <Header />
      <main className="relative z-10">
        <Hero />
        <Introducing />
        <Features />
        <Performance />
        <HowItWorks />
        <NextMoves />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/get-started" element={<GetStartedPage />} />
      </Routes>
      <Toaster position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
